// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"e12147f8","507":"4e843896","963":"97793b2b"}[chunkId] + ".chunk.js";
};